<template>
    <div id="master-detailpage">
        <TabView v-model:activeIndex="activeTab">
            <template v-if="$auth.canView('chats/list')">
                <TabPanel>
                    <template #header>
                        <div class=" text-lg font-bold" >
                            Complaints Chats
                        </div>
                    </template>
                    <div>
                        <ChatsListPage ref="chatsListPage"  field-name="chats.complaint_id" :field-value="masterRecord.complaint_id" :show-header="true" v-if="pageReady">
                        </ChatsListPage>
                    </div>
                </TabPanel>
            </template>
        </TabView>
    </div>
</template>
<script setup>
import { watch, computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useApp } from '@/composables/app.js';
import { useAuth } from '@/composables/auth';
import ChatsListPage from "../chats/list.vue";
const props = defineProps({
	isSubPage: {
		type : Boolean,
		default : true,
	},
	scrollIntoView: {
		type : Boolean,
		default : false,
	},
});
const app = useApp();
const auth = useAuth();
const store = useStore();
const masterRecord = computed(() => store.getters['complaints/currentRecord']);
const activeTab = ref(0);
const pageReady = ref(true);
//scroll detail page into view
function scrollToDetailPage() {
	if (props.scrollIntoView) {
		const pageElement = document.getElementById('master-detailpage');
		if(pageElement){
			pageElement.scrollIntoView({behavior:'smooth', block:'start'});
		}
	}
}
// pass form data from master to detail
function setDetailPageFormData(){
	const record = masterRecord.value;
	// set  form data
	const chatsFormData = { complaint_id:record?.complaint_id }
	store.commit('chats/setFormData', chatsFormData);
}
watch(() => masterRecord, (current) => {
		setDetailPageFormData();
		scrollToDetailPage();
	},
	{ deep: true, immediate: true }
);
onMounted(()=>{ 
    scrollToDetailPage();
});
</script>
